import { mountVue } from '../vue/mountVue';
import Search from '../vue/Search/SearchInput.vue';

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.clickSearchIcon();
    this.clickTryAgain();
  }

  clickSearchIcon() {
    document.querySelectorAll('.header__search').forEach((searchIcon) => {
      searchIcon.addEventListener('click', (e) => {
        if (
          e.target.matches('.header__search svg') ||
          e.target.parentElement.matches('.header__search svg') ||
          e.target.matches('.header__search span')
        ) {
          this.initSearch();
        }
      });
    });
  }

  clickTryAgain() {
    if (document.querySelector('.template-search--empty')) {
      document
        .querySelector('.results__button')
        .addEventListener('click', (e) => {
          this.initSearch();
        });
    }
  }

  initSearch() {
    const rect = document
      .querySelector('sticky-header, static-nav')
      .getBoundingClientRect();
    this.style.top = `${rect.top}px`;
    this.toggle();
    if (this.querySelector('.js-main-search'))
      mountVue('.js-main-search', Search, this);
  }

  toggle() {
    this.classList.toggle('hidden');
    document
      .querySelector('.predictive-search--overlay')
      .toggleAttribute('open');
    if (
      document
        .querySelector('.predictive-search--overlay')
        ?.hasAttribute('open') &&
      !!document.querySelector('.search__bar--input')
    )
      document.querySelector('.search__bar--input').focus();
    document.documentElement.classList.toggle('overflow-hidden');
  }
}

customElements.define('predictive-search', PredictiveSearch);
